module.exports = __webpack_public_path__ + "static/media/process_3.0ba4e26c.svg";